import { Injectable } from "@angular/core";
import { StorageService } from "../../core/services/storage.service";
import { Router } from "@angular/router";
import { EventDetailsResponseModel } from "./home.model";
import { firstValueFrom } from "rxjs";
import { APIErrorModel, BaseResponse } from "../../shared/models/base-response.model";
import { HttpResult } from "../../core/services/base-http.service";
import { HomeApiService } from "./home-api.service";

@Injectable({
  providedIn: "root",
})
export class HomeBllService {
  constructor(
    private storageService: StorageService,
    private router: Router,
    private api: HomeApiService
  ) { }

  homeInitStorageChanges(eventcode?: any, refSource?: string): void {
    if (eventcode !== null && eventcode !== undefined) {
      this.storageService.saveEventCode(eventcode);
    }
    if (refSource) {
      this.storageService.saveRefSource(refSource);
    }
    this.storageService.clearRazorpayData();
    this.storageService.clearSummaryId();

  }

  isHomePage(): boolean {
    return this.router.url === "/" || this.router.url.startsWith("/home");
  }

  isPromotionPage(): boolean {
    return this.router.url.startsWith("/promotion-marathi") || this.router.url.startsWith("/promotion-english");
  }

  clearRefSource(): void {
    this.storageService.clearRefSource();
  }
  /**
   * Retrieves or creates a Bootstrap modal instance for the given HTML element.
   *
   * @param {HTMLElement} element - The HTML element to associate with the Bootstrap modal.
   * @returns {any} The Bootstrap modal instance associated with the element.
   * @throws {Error} If Bootstrap JS is not loaded or the Modal class is not available.
   */
  getBootstrapModal(element: HTMLElement): any {
    // Try get existing instance — if none, create new
    const bs = (window as any).bootstrap;
    if (!bs || !bs.Modal) {
      throw new Error('Bootstrap JS not loaded or Modal not available');
    }

    // Use getOrCreateInstance if available
    const modal = bs.Modal.getOrCreateInstance
      ? bs.Modal.getOrCreateInstance(element)
      : (bs.Modal.getInstance(element) || new bs.Modal(element));
    return modal;
  }

  /**
   * Fetch event details
   */
  async fetchEventDetails(): Promise<BaseResponse<EventDetailsResponseModel>> {
    const result: HttpResult<BaseResponse<EventDetailsResponseModel>> =
      await firstValueFrom(this.api.getEventDetails());

    const { status, body } = result;
    if (status === 200) {
      return body;
    } else {
      throw <APIErrorModel>{
        status,
        message: body.message,
        data: body.data,
      };
    }
  }

}
